import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { format } from "date-fns";
import { CircularProgress, MenuItem } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import ic_filter from "../utils/ic_filter.png";
import TextField from "@mui/material/TextField";
import useApi from "../hooks/useApi";
import { ArrowLeft, ArrowRight } from "lucide-react";
import PaginationControls from "../components/lead_and_quotation/PaginationControls";
import ReusableTable from "../components/lead_and_quotation/TableListViewFull";
import QuotationDetailsPopup from "../components/lead_and_quotation/QuotationDetailsPopup";

const SalesOrderListViewFull = (props) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];

  let defaultStage = "-";
  const [currentSelectedStage, setCurrentSelectedStage] =
    useState(defaultStage);

  const todayDate = format(new Date(), "yyyy-MM-dd");

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

  const userAccessGroup = currentUserObject[0].accessgrp;

  const [initialFilterObject, setInitialFilterObject] = useState({
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_creator_id:
      userAccessGroup?.trim().toUpperCase() === "COORDINATOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    task_owner_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
      userAccessGroup?.trim().toUpperCase() != "ADMIN"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    free_text: "-",
  });

  const [showLeadFilter, setShowLeadFilter] = useState(false);
  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [quotationList, setQuotationList] = useState(null);
  const [quotationDetailsData, setQuotationDetailsData] = useState(null);
  const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const callAPI = () => {
    console.log("currentPageNumber ", currentPageNumber);

    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    );
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    if (!currentUserObject) {
      console.error("No user data found in localStorage");
      return;
    }

    const userAccessGroup = currentUserObject[0].accessgrp;

    console.log("currentUserDepartment:", currentUserDepartment);
    console.log("userAccessGroup:", userAccessGroup);

    fetchQuotationList(
      userAccessGroup,
      currentUserDepartment,
      initialFilterObject,
      empIDFromUserObjectInLocalStorage,
    );
  };

  const handleChange = (e) => {
    setCurrentSelectedStage(e.target.value);
  };
  useEffect(() => {
    if (currentPageNumber) {
      callAPI();
    }
  }, [currentPageNumber]);

  const { request, loading: loadingQuotationList, error } = useApi();
  const fetchQuotationList = async (
    userAccessGroup,
    currentUserDepartment,
    filterObjectFromModal,
    empIDFromUserObjectInLocalStorage,
  ) => {
    console.log("filterObjectFrom Modal", filterObjectFromModal);

    setLoading(true);

    try {
      let url = "";

      if (userAccessGroup === "ADMIN") {
        url = `${API_PATHS[0].API_CONFIG}/api/CRMTaskMainListFilter/${COMPANY_CODE}/salesorderfilter/${filterObjectFromModal.task_owner_id}/${filterObjectFromModal.task_creator_id}/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/-`;
      } else if (userAccessGroup === "COORDINATOR") {
        url = `${API_PATHS[0].API_CONFIG}/api/CRMTaskMainListFilter/${COMPANY_CODE}/salesorderfilter/-/${filterObjectFromModal.task_creator_id}/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${currentSelectedStage}`;
      } else {
        url = `${API_PATHS[0].API_CONFIG}/api/CRMTaskMainListFilter/${COMPANY_CODE}/salesorderfilter/${filterObjectFromModal.task_owner_id}/-/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${currentSelectedStage}`;
      }

      const response = await request({
        url: url,
        method: "GET",
        timeout: 5000,
      });
      console.log("Quotation List:", response);
      setQuotationList(response);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {};

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  const goToAdminSalesOrderDetails = (clickedListItem) => {
    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_account: clickedListItem.Account,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_coordinator: clickedListItem.Coordinator,
      deptno: clickedListItem.Dept,
    };
    console.log("selectedLead>>> Admin List", selectedLead);

    navigate(`/sales_order_details_admin`, { state: { selectedLead } });
  };

  const goToUserSalesOrderDetails = (clickedListItem) => {
    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_coordinator: clickedListItem.Coordinator,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_account: clickedListItem.Account,
      deptno: clickedListItem.Dept,
    };
    console.log("selectedLead>>>", selectedLead);

    navigate("/sales_order_details_user", { state: { selectedLead } });
  };

  const handleInput = (e) => {
    if (e.target.value === "") {
      setInitialFilterObject((prev) => ({ ...prev, free_text: "-" }));
    } else {
      setInitialFilterObject((prev) => ({
        ...prev,
        free_text: [e.target.value],
      }));
    }
  };

  useEffect(() => {
    if (initialFilterObject) {
      console.log("freetext changed calling api");
      callAPI();
    }
  }, [initialFilterObject]);

  useEffect(() => {
    if (currentSelectedStage) {
      callAPI();
    }
  }, [currentSelectedStage]);

  const salesOrderConfig = {
    columns: [
      { header: "Sales Order Number", accessor: "Salesorder_No" },
      { header: "Date", accessor: "Date", type: "date" },
      { header: "LPO No.", accessor: "LPO No" },
      { header: "Customer Name", accessor: "Customer", trim: true },
      { header: "Customer Account", accessor: "Account" },
      { header: "Amount", accessor: "Amount" },
      {
        header: "Salesperson",
        accessor: "Sales_Person",
        render: (value, item) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{item.Sales_Person?.trim()}</span>
            <span>{item.Sales_person_Name?.trim()}</span>
          </div>
        ),
      },
      { header: "Dept No", accessor: "Dept" },
      { header: "Status", accessor: "Stage", type: "status" },
      {
        header: "Action",
        type: "actions",
        headerClassName: "text-center w-[240px]",
        actions: [
          {
            label: "Quotation Details",
            className:
              "bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs",
            condition: (item, userGroup) =>
              userGroup?.trim().toUpperCase() === "ADMIN",
            onClick: (item) => goToAdminSalesOrderDetails(item),
          },
          {
            label: "Details",
            className:
              "bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs",
            condition: (item, userGroup) =>
              userGroup?.trim().toUpperCase() !== "ADMIN",
            onClick: (item) => goToUserSalesOrderDetails(item),
          },
        ],
      },
    ],
  };

  return (
    <div className="min-h-screen lg:px-6 px-3 overflow-x-auto lg:w-full w-[100vw]">
      <div className="flex items-center justify-between mb-6 lg:px-2">
        <h3 className="text-xl font-normal text-gray-800 ">Sales Order List</h3>

        {/* <button style={{ display: "flex", alignItems: "center" }} onClick={() => setShowLeadFilter((prev) => !prev)}>
          <img style={{ width: "15px", height: "15px" }} src={ic_filter} />
          Filter
        </button>{" "} */}
        {/* <input className="rounded me-2" placeholder="Search in Sales Order" onChange={(e) => handleInput(e)} /> */}
        {/* <div className="me-4">
          <TextField
            select
            label={"Stage"} // Dynamically updated label
            name="territory"
            value={currentSelectedStage}
            onChange={handleChange}
            fullWidth
            variant="standard"
            id="territory"
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Figtree, sans-serif",
              },
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important", // Removes any shadow applied
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Stage
            </MenuItem>
            <MenuItem value="-">All</MenuItem>
            <MenuItem value="Draft">Draft</MenuItem>
            <MenuItem value="For Approval">For Approval</MenuItem>
            <MenuItem value="Approved">Approved</MenuItem>
            <MenuItem value="Customer Submission & Awaiting Approval">Customer Submission & Awaiting Approval</MenuItem>
            <MenuItem value="Customer Approval">Customer Approval</MenuItem>
            <MenuItem value="Customer Rejection-Negotiation">Customer Rejection-Negotiation</MenuItem>

          </TextField>
        </div> */}
        <PaginationControls
          setCurrentPageNumber={setCurrentPageNumber}
          currentPageNumber={currentPageNumber}
          data={quotationList}
          itemsPerPage={100}
        />
      </div>

      <div className="w-full overflow-x-auto">
        <ReusableTable
          data={quotationList}
          columns={salesOrderConfig.columns}
          currentUserAccessGroup={currentUserAccessGroup}
        />
      </div>
      {loading ? (
        <p className="inset-0 fixed flex justify-center items-center">
          Loading quotations... <CircularProgress size={24} />
        </p> // Show loader while fetching
      ) : (
        <ul>
          {/* {quotationList?.map((quote, index) => (
            <li key={index}>{quote.name}</li>
          ))} */}
        </ul>
      )}

      {showLeadFilter && (
        <QuotationListFilterModal
          applyFilters={applyFilters}
          closeFilter={() => setShowLeadFilter(false)}
          fetchQuotationList={fetchQuotationList}
        />
      )}
    </div>
  );
};

export default SalesOrderListViewFull;
